import cookie from 'js-cookie'

/**
 * @description 获取存储在本地的用户信息
 * @returns {*}
 */
export function getLocalUserInfo() {
  let data = null
  try {
    data = JSON.parse(cookie.get('UID'))
  } catch (e) {
    data = void 0
  }
  return data
}
export function setLocalUserInfo(userInfo) {
  cookie.set('UID', JSON.stringify(userInfo), {
    expires: 7
  })
}

/**
 * @description 移除token
 */
export function removeToken() {
  cookie.remove('SID')
  cookie.remove('UID')
}
export function getToken() {
  return cookie.get('SID')
}
/**
 * @description 设置本地token与用户信息
 * @param user
 */
export function setToken(user) {
  const { token } = user
  cookie.set('SID', token, {
    expires: 7
  })
  if (getLocalUserInfo()) {
    cookie.set('UID', getLocalUserInfo(), {
      expires: 7
    })
  }
  if (user) {
    setLocalUserInfo(user)
  }
}
